import React from 'react';
import items from '../data/about.json';
import Gallery from './Gallery';

function About() {
  return (
    <div className='about'>
      <div className='container'>
        <h3 className='text-primary'>Sobre Nosotros</h3>
        <h4 className='mb-1'>Desde 1982 Generando Confianza</h4>
        <p className='mb-5'>
          Nos dedicamos a la consignación de hacienda bovina y la venta de
          insumos para el agro.
        </p>
        <Gallery photos={items.data} />
      </div>
    </div>
  );
}

export default About;
